import React from 'react';
import { PrincipalContainer, TextboxWarning, Title, Message } from './styles';

export default ({
  status = 'normal',
  title = '',
  message,
  display = '',
  inputStyle = '',
}: {
  status?: string;
  title?: string;
  message: string;
  display?: string
  inputStyle?: string
}) => (
  <PrincipalContainer status={status} display={display}>
    <TextboxWarning inputStyle={inputStyle}>
      <Title inputStyle={inputStyle}>{title}</Title>
      <Message inputStyle={inputStyle}>
        {message}        
      </Message>
    </TextboxWarning>
  </PrincipalContainer>
);
